// Theme JavaScript
(function() {
    'use strict';

    // Add any theme-specific JavaScript here
    console.log('Theme JavaScript loaded');
})(); 